enum STATUS {
  connected = 'connected',
  disconnected = 'disconnected',
  inReview = 'inReview',
  actionNeeded = 'actionNeeded',
}

export default STATUS;
